var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Posts / Custom Post Types")]),_c('h2',[_vm._v("\n    "+_vm._s(_vm.$route.params.type ||
        "posts/:type Dynamic route varaiable example: posts/my-custom will output my-custom")+"\n  ")]),_c('user-test')],1)}
var staticRenderFns = []

export { render, staticRenderFns }